import type { SrcSetSizes } from '@snapchat/mw-contentful-client';
import { mobileMaxWidth } from '@snapchat/snap-design-system-marketing';

/*
This is a global fallback image to display on summary card when the user doesn't provide an image for the gallery or tile.
This image is in the global-components contentful space
*/
export const globalDefaultImage =
  'https://images.ctfassets.net/kp51zybwznx4/120IJvdruE5HeC9XBYjFiU/879b8f63bde0d27c0750ade94c4b1a39/Default_Gallery_Image.png';

export const defaultImageAltText = 'Snap Inc.';

export const defaultDateOptions: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  // NOTE: Always render these dates assuming UTC timezone to ensure consistent rendering between server and client.
  //       Otherwise we would need to determine the client's timezone whenever we process the initial render on the server.
  //       By using UTC for all cases we ensure consistent behavior, though we may be off by 1 day depending on the user's
  //       location.
  timeZone: 'UTC',
};

export const editorialGalleryDateOptions: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: '2-digit',
  timeZone: 'UTC',
};

// 450 height on desktop, 360 height on mobile.
export const imageHeights = [360, 450];
export const imageHeightsStr = imageHeights.map(ih => `${ih}px`).join(', ');

export const getGalleryImgSrcSetSizes = (quality: number): SrcSetSizes => ({
  sizeToUrl: imageHeights.map(height => ({
    // We can only use width descriptor so... even though it says 'w' it's not really its width.
    // This way the browser will still use the correct one since we are telling it at mobile
    // to use 360w and on desktop to use 450w.
    size: `${height}w`,
    settings: { height, quality },
  })),
  sizes: `(max-width: ${mobileMaxWidth}px) ${imageHeightsStr}`,
});
